module.exports = __webpack_public_path__ + "img/logo-icon2.3408bb99.png";